import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getBanner, removeBanner } from 'slice/bannerSlice';
import AdminTable from 'common/AdminTable';

const BannerList = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const bannerState = useSelector((state) => state.banner);
    const banners = Array.isArray(bannerState?.data) ? bannerState.data : [];

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Heading',
            accessor: 'heading',
        },
        {
            Header: 'Sub Heading',
            accessor: 'sub_heading',
        },
        {
            Header: 'Image',
            accessor: 'image',
            Cell: ({ row }) => (
                <img
                    src={`${process.env.REACT_APP_BACKEND}banner/${row.original.image}`}
                    alt={row.original.heading}
                    width={100}
                    style={{ borderRadius: '4px', objectFit: 'cover' }}
                />
            ),
        },
        {
            Header: 'Status',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <span className={`badge ${row.original.is_active ? 'badge-success' : 'badge-danger'}`}>
                    {row.original.is_active ? 'Active' : 'Inactive'}
                </span>
            )
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <div className="d-flex gap-2">
                    <button
                        className="btn btn-sm btn-info mr-2"
                        onClick={() => navigate(`/banner/update/${row.original.id}`)}
                    >
                        Edit
                    </button>
                    <button
                        className="btn btn-sm btn-danger removebtn"
                        onClick={() => {
                            if (window.confirm('Are you sure you want to delete this banner?')) {
                                dispatch(removeBanner(row.original.id));
                            }
                        }}
                    >
                        Remove
                    </button>
                </div>
            ),
        },
    ];

    useEffect(() => {
        dispatch(getBanner())
    }, [dispatch])

    return (
        <>
            <div className="container-fluid mt-5">
                <div className="mainheadig mx-4">
                    <h4 className="font-weight-bold">Banner List</h4>
                </div>
                {banners.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={banners} />
                ) : (
                    <div className="text-center mt-5">
                        <p className="text-white">No banners available</p>
                    </div>
                )}
            </div >
        </>
    )
}

export default BannerList;
